<template>
  <div class="seach-container js">
    <div class="pc-search pc-search-show">
      <div class="seach">
        <div class="seach-bg">
          <div class="seach-bg-img kb-enabled in-viewport">
            <img loading="lazy" class="theme-img js" style=" object-fit:cover;object-position:50.0% 50.0%!important;" src="@/assets/seach/banner.png" alt="">
          </div>
          <div class="seach-bg-breadcrumb">
            <div class="seach-bg-breadcrumb-cont">
              <div class="seach-bg-breadcrumb-icon">
                <i class="el-icon-search i-in"></i>
              </div>
              <div class="seach-bg-breadcrumb-input">
                <el-input v-model="seachInput" :placeholder="$t('seach.placeholder')"
                  @keyup.enter.native="seachQuery"></el-input>
              </div>
              <div class="seach-bg-breadcrumb-btn">
                <div class="seach-bg-breadcrumb-btn-item">
                  <button @click="seachQuery" class="button-slide-in">{{ $t('seach.button') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="seach-cont">
          <div class="seach-cont-list">
            <div class="seach-cont-list-item" v-for="(item, index) in searchList" :key="index" @click="goDetail(item)">
              <div class="seach-cont-list-item-title">
                <strong>{{ item.title }}</strong>
              </div>
              <!-- <div class="seach-cont-list-item-content">{{ item.text }}</div> -->
              <div class="seach-cont-list-item-content" v-html="item.des"></div>
              <!-- <div class="seach-cont-list-item-iconText">
              <div class="seach-cont-list-item-iconText-icon">
                <img :src="item.img" alt="">
              </div>
              <div class="seach-cont-list-item-iconText-text">{{ item.breadcrumb }}</div>
            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-seach mobile-search-show">
      <div class="seach">
        <div class="seach-bg">
          <div class="seach-bg-img">
            <img src="../../assets/searchMb/banner .png" alt="">
          </div>
          <div class="seach-bg-breadcrumb">
            <div class="seach-bg-breadcrumb-cont">
              <div class="seach-bg-breadcrumb-icon">
                <i class="el-icon-search"></i>
              </div>
              <div class="seach-bg-breadcrumb-input">
                <el-input v-model="seachInput" :placeholder="$t('seach.placeholder')"></el-input>
              </div>
              <div class="seach-bg-breadcrumb-btn">
                <div class="seach-bg-breadcrumb-btn-item">
                  <button @click="seachQuery">{{ $t('seach.button') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="blogs-news">
          <div class="blogs-news-item" v-for="(item, index) in searchList" :key="index">
            <!-- <div class="item-image">
              <img :src="item.image" alt=""></img>
            </div> -->
            <div class="item-title"><strong>{{ item.title }}</strong></div>
            <div class="item-content" v-html="item.des"></div>
            <div class="item-more-bnt" @click="goDetail(item)">更多详情</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from '@/api/komo'
export default {
  name: 'seach',
  data() {
    return {
      seachInput: '',
      seachList: [
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        },
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        },
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        }
      ],
      searchList: [],
      isShow: true,
      chidList: {
        tabName: '',
        id: ''
      }
    };
  },
  mounted() {
    // 触发动画的另一种方式（如果CSS动画不生效）
    this.$nextTick(() => {
      const iins = document.querySelectorAll('.i-in');
      const buttons = document.querySelectorAll('.button-slide-in');
      setTimeout(() => {
        buttons.forEach(button => {
          button.style.animation = 'slideInRight 0.5s ease-out forwards';
        });
        iins.forEach(iin => {
          iin.style.animation = 'slideInLeft 0.5s ease-out forwards';
        });
      }, 200); // 延迟按钮动画
    });
  },
  methods: {
    seachQuery() {
      console.log('seachInput111111', this.seachInput)
      this.searchData(this.seachInput)
    },
    goDetail(item) {
      this.$router.push({
        name: 'theEditDetail',
        params: {
          id: item.id
        }
      })
    },
    async searchData(search) {
      this.searchList = [];
      let params = {
        type: '',
        search: search
      }
      const searchDatalist = await getNewsList(params);
      this.searchList = searchDatalist.data.list;
    },
  },
  created() {
    this.searchList = [];
  }
};
</script>

<style scoped lang="scss">
.pc-search {

  /* 样式部分 */
  .seach {
    width: 100%;
    height: 100%;
    background: #F8F9FC;
  }

  .seach-bg {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 2%;
  }

  .seach-bg-img {
    width: 100%;
    height: 580px;
  }

  .seach-bg-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border: 0 none;
    max-width: 100%;
    object-fit: cover;
    object-position: 50.0% 50.0% !important;
    aspect-ratio: auto 2048 / 2048;
  }

  .seach-bg-breadcrumb {
    width: 80%;
    height: 50px;
    background: #FFFFFF;
    box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
    border-radius: 60px;
    position: absolute;
    top: calc(580px - 2vw);
    left: 10%;
    z-index: 1
  }

  .seach-bg-breadcrumb-cont {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 12% 0 2%;
  }

  .seach-bg-breadcrumb-icon {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seach-bg-breadcrumb-icon i {
    font-size: 1.2rem;
  }

  .seach-bg-breadcrumb-input {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seach-bg-breadcrumb-input :deep(.el-input) {
    height: 100%;
  }

  .seach-bg-breadcrumb-input :deep(.el-input__inner) {
    border: none!important;
    font-size: 1rem;
    height: 100%;
  }

  .seach-bg-breadcrumb-btn {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 4px;
  }

  .seach-bg-breadcrumb-btn-item {
    // width: 93%;
    // height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4% 0;
  }

  .seach-bg-breadcrumb-btn-item button {
    border: none;
    // width: 100%;
    // height: 100%;
    border-radius: 2vw 2vw 2vw 2vw;
    background-color: #1e1e1e;
    box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
    color: #fff;
    font-size: 1rem;
  }


  /* 内容 */
  .seach-cont {
    width: 100%;
    height: 100%;
    padding: 4% 0 6%;
  }

  .seach-cont-list {
    width: 80%;
    height: 100%;
    margin: 0 auto;
  }

  .seach-cont-list-item {
    padding: 3% 0% 1%;
    border-bottom: 1px solid #95959591;
    display: flex;
    flex-direction: column;
    gap: 1vw;

  }

  .seach-cont-list-item-title {
    font-size: 1.5rem;
  }

  .seach-cont-list-item-content {
    font-size: 1.1rem;
    color: #1E1E1E;
  }

  .seach-cont-list-item-iconText {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  .seach-cont-list-item-iconText-icon {
    width: 1vw;
    height: 1vw;
    display: flex;
  }

  .seach-cont-list-item-iconText-icon img {
    width: 100%;
    height: 100%;
  }

  .seach-cont-list-item-iconText-text {
    color: #959595;
    font-size: 1rem;
  }
}

.mobile-seach {
  .seach {
    width: 100%;
    height: 100%;
    background: #F8F9FC;
  }

  .seach-bg {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 2%;
  }

  .seach-bg-img {
    width: 100%;
    /* height: 580px; */
  }

  .seach-bg-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .seach-bg-breadcrumb {
    width: 80%;
    height: 6vw;
    background: #FFFFFF;
    box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
    border-radius: 20vw;
    position: absolute;
    bottom: -1vw;
    left: 10%;
    z-index: 1
  }

  .seach-bg-breadcrumb-cont {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 12% 0 4%;
  }

  .seach-bg-breadcrumb-icon {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seach-bg-breadcrumb-icon i {
    font-size: 3vw;
  }

  .seach-bg-breadcrumb-input {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .seach-bg-breadcrumb-input :deep(.el-input) {
    height: 100%;
  }

  .seach-bg-breadcrumb-input :deep(.el-input__inner) {
    border: none!important;
    font-size: 2vw;
    height: 100%;
  }

  .seach-bg-breadcrumb-btn {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    width: 20vw;
  }

  .seach-bg-breadcrumb-btn-item {
    width: 93%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 0;
  }

  .seach-bg-breadcrumb-btn-item button {
    border: none;
    width: 100%;
    height: 100%;
    border-radius: 10vw;
    background-color: #1e1e1e;
    box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
    color: #fff;
    font-size: 2.5vw;
  }


  /* 内容 */
  .seach-cont {
    width: 100%;
    height: 100%;
    padding: 4% 0 6%;
  }

  .seach-cont-list {
    width: 80%;
    height: 100%;
    margin: 0 auto;
  }

  .seach-cont-list-item {
    padding: 3% 0% 1%;
    border-bottom: 1px solid #95959591;
    display: flex;
    flex-direction: column;
    gap: 1vw;

  }

  .seach-cont-list-item-title {
    font-size: 5rem;
  }

  .seach-cont-list-item-content {
    font-size: 3rem;
    color: #1E1E1E;
  }

  .seach-cont-list-item-iconText {
    display: flex;
    gap: 0.5vw;
    align-items: center;
  }

  .seach-cont-list-item-iconText-icon {
    width: 3vw;
    height: 3vw;
    display: flex;
  }

  .seach-cont-list-item-iconText-icon img {
    width: 100%;
    height: 100%;
  }

  .seach-cont-list-item-iconText-text {
    color: #959595;
    font-size: 3rem;
  }

  /* BLOGS NEWS */
  .blogs-news {
    width: 100%;
    padding: 6% 12px;
  }

  .blogs-news-item {
    width: 100%;
    background: #FFFFFF;
    padding: 10px;
    border-radius: 20px;
    margin-bottom: 20px;
  }

  .blogs-news-item:last-child {
    margin-bottom: 0;
    /* 最后一个元素取消 margin */
  }

  .blogs-news-item .item-image {
    width: 100%;
  }

  .blogs-news-item .item-image img {
    width: 100%;
  }

  .blogs-news-item .item-title {
    font-size: 5rem;
    font-weight: bold;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    line-height: 5vh;
  }

  .blogs-news-item .item-content {
    font-size: 3rem;
    font-family: MicrosoftYaHei;
    color: #959595;
  }

  .blogs-news-item .item-more-bnt {
    width: 24vw;
    height: 10vw;
    border-radius: 30px;
    border: 1px solid #979797;
    font-size: 1rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: #1e1e1e;
    margin: 20px 0 10px 0;
  }
}

.mobile-search-show {
  display: none;
}
.kb-enabled{
  overflow: hidden;
}

/* 按钮从右边滑入动画 */
.button-slide-in {
  animation: slideInRight 0.5s ease-out forwards;
  animation-delay: 0.2s; /* 延迟动画开始 */
  transform: translateX(60px);
}
.i-in{
  animation: slideInLeft 0.5s ease-out forwards;
  animation-delay: 0.2s; /* 延迟动画开始 */
  transform: translateX(-60px);
}

/* 右侧滑入关键帧 */
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-60px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media screen and (min-width: 768px) {
  .pc-search .seach-bg-breadcrumb{
    height: 50px;
  }
  .pc-search .seach-bg-breadcrumb-btn-item button{
    padding: 10px 30px;
  }
   /* 图片动画 - 从大变小 */
  .kb-enabled > * {
    transform: translate3d(.25rem, .12rem, .25rem) scale(1.06);
    transform-origin: left center;
    transition: transform 2s ease;
  }
  
  /* 添加延迟，确保动画触发 */
  .kb-enabled.in-viewport > * {
    animation: scaleDown 2s ease forwards;
    transform-origin: left center;
  }
}
@media screen and (max-width: 900px) {
  .pc-search .seach-bg-breadcrumb-btn {
    right: 8px;
  }
  .pc-search .seach-bg-breadcrumb-btn-item button{
    padding: 6px 24px;
  }
}
@media screen and (max-width: 768px) {
  .pc-search-show {
    display: none;
  }

  .mobile-search-show {
    display: block;
  }
}
@media (prefers-reduced-motion: reduce) {
  .kb-enabled > * {
    transition: none !important;
  }
}
.seach-container{
   padding: var(--nav-max-height) 0 0;
    display: block;
}
@media (max-width: 1115px) {
    .seach-container {
        padding: var(--nav-1115-height) 0 0;
    }
}

@media (max-width: 990px) {
    .seach-container {
        padding: var(--nav-990-height) 0 0;
    }
}
</style>